import { render, staticRenderFns } from "./property.vue?vue&type=template&id=6e789338&scoped=true"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"
import style0 from "./property.vue?vue&type=style&index=0&id=6e789338&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e789338",
  null
  
)

export default component.exports